const Alyglo = ({ themeColor }: { themeColor: string }) => {
  return (
    <>
      <div className="mx-auto pb-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}> MEDICAL BENEFITS BILLING PORTAL FOR PROVIDERS.</span>
          <p className="my-2">SITE-OF-CARE DRIVEN COPAY ASSISTANCE.</p>
        </div>

        <p className="my-2">
          If your patient’s primary payer drug claim is billed under medical benefits, you can
          request ALYGLO (immune globulin intravenous, human-stwk), 10% Liquid copay assistance
          using this portal. Eligible patients can receive up to $15,000 to cover the deductible,
          copay, and/or coinsurance for ALYGLO. Note: Nursing and supply costs that may be
          associated with the administration of the medication are not eligible for assistance
          through this program.
        </p>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</div>

        <ul className="my-2 list-disc ml-10">
          <li>Patient must be a US resident</li>
          <li>Patient must express financial need</li>
          <li>Assistance is available to commercially insured patients only</li>
        </ul>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Assistance covers only out-of-pocket expenses for the drug portion; administration
            supplies and nursing copay costs are not covered through the program
          </li>
          <li>
            Patients are ineligible for copay assistance if they participate in Medicare, Medicaid,
            Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or
            state-funded programs.
          </li>
        </ul>
      </div>
    </>
  );
};

export default Alyglo;
